import { RootState } from 'store';

export const selectors = {
  selectFlashcardsPacks: (state: RootState) => state.flashcardsPacks.flashcardsPacks,
  selectFlashcardsPacksMeta: (state: RootState) => state.flashcardsPacks.meta,
  selectMarkedForReCheckingCount: (state: RootState) => state.flashcardsPacks.markedForReCheckingCount,
};
